import OsqueryVersionDropdown from './OsqueryVersionDropdown'

export default OsqueryVersionDropdown
